/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'
import AnimatedAvatar from './AnimatedAvatar'
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore/lite';
import { AuthModel } from '../models/AuthModel';
import { UserModel } from '../models/UserModel';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

const firebaseConfig = {
  apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
  authDomain: "gj08-6e7ea.firebaseapp.com",
  projectId: "gj08-6e7ea",
  storageBucket: "gj08-6e7ea.appspot.com",
  messagingSenderId: "527457566258",
  appId: "1:527457566258:web:da78475eabd5ae580b062b",
  measurementId: "G-KGVQ6TS2WV"
};

interface inputEventHandler {
  onEmailFocus(e:any): void;
  onEmailBlur(e:any): void;
  onEmailInput(e:any): void;
  onPasswordFocus(e:any): void;
  onPasswordBlur(e:any): void;
}

/*
Formik+YUP+Typescript:
https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const child = useRef<inputEventHandler>(null);
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        // firebase login
        loginUserFromFirebase(values.email, values.password, values)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login detail is incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const svgContainerStyle = {
    width: "150px",
    height: "150px",
    margin: "0 auto 1em",
    borderRadius: "50%",
    background: "none",
    border: "solid 2.5px #3A5E77",
    overflow: "hidden",
  }

  // Firebase variables
  const firebaseApp = initializeApp(firebaseConfig);
  const firebaseDB = getFirestore(firebaseApp);
  const firebaseAuth = getAuth(firebaseApp);
  const provider = new GoogleAuthProvider();

  // Firebase methods - start
  const loginUserFromFirebase = (email: string, password: string, values: any) => {
    console.log("loginUserFromFirebase");
    signInWithEmailAndPassword(firebaseAuth, email, password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log("user: ", user);
        userCredential.user.getIdToken().then(function (token) {
          console.log("accessToken: ", token);
          const authModel: AuthModel = {
            api_token: token,
            refreshToken: userCredential.user.refreshToken,
          };
          // Store User Primary ID
          values.id = user.uid;
          saveAuth(authModel)
        });
        console.log("user.refreshToken: ", userCredential.user.refreshToken);
        getUserRecordFromFirestoreDB(values)
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/user-not-found':
            console.log(`User with this email: ${email} doesn't exist.`);
            formik.setStatus(`User with this email: ${email} doesn't exist.`)
            setLoading(false);
            break;
          case 'auth/invalid-email':
            console.log(`Email address ${email} is invalid.`);
            formik.setStatus(`Email address ${email} is invalid.`)
            setLoading(false);
            break;
          case 'auth/operation-not-allowed':
            console.log(`Error during sign in.`);
            formik.setStatus(`Error during sign in.`)
            setLoading(false);
            break;
          case 'auth/weak-password':
            console.log('Password is not strong enough. Add additional characters including special characters and numbers.');
            formik.setStatus('Password is not strong enough. Add additional characters including special characters and numbers.')
            setLoading(false);
            break;
          default:
            console.log(error.message);
            formik.setStatus(error.message)
            setLoading(false);
            break;
        }
      });
  }

  async function getUserRecordFromFirestoreDB(values: any) {
    try {
      const q = query(collection(firebaseDB, "students"), where("email", "==", values.email));
      const facilitatorCollectionQuery = query(collection(firebaseDB, "facilitators"), where("email", "==", values.email));
      let querySnapshot = await getDocs(q);
      // If on student collection value is emmpty check on facilitator collection
      if(querySnapshot.empty) {
        querySnapshot = await getDocs(facilitatorCollectionQuery);
      }
      querySnapshot.forEach((user) => {
        console.log("user from DB: ", user.data());

        if (user.data().isfacilitator === "false") {
          // load student model
          const userModel: UserModel = {
            id: values.uid ? values.uid : values.id,
            username: user.data().email,
            email: user.data().email,
            password: values.password,
            first_name: user.data().firstname,
            last_name: user.data().lastname,
            fullname: user.data().firstname + " " + user.data().lastname,
            occupation: "student",
            phone: user.data().phonenumber,
            address: user.data().location,
            // student fields
            class: user.data().class,
            country: user.data().country,
            dateOfBirth: user.data().dateofbirth,
            isFacilitator: user.data().isfacilitator,
            school: user.data().school,
            state: user.data().state,
            uniqueIdentificationNumber: user.data().uniqueidentificationnumber,
          };

          setCurrentUser(userModel);
          console.log("student Model: ", userModel);
        }
        else {
          // load facilitator model
          const userModel: UserModel = {
            id: values.uid ? values.uid : values.id,
            username: user.data().email,
            email: user.data().email,
            password: values.password,
            first_name: user.data().firstname,
            last_name: user.data().lastname,
            fullname: user.data().firstname + " " + user.data().lastname,
            occupation: "facilitator",
            phone: user.data().phonenumber,
            address: user.data().location,
            dateOfBirth: user.data().dateofbirth,
            // facilitator fields
            phoneNumber: user.data().phonenumber,
            grade: user.data().grade,
            location: user.data().location
          };

          setCurrentUser(userModel);
          console.log("facilitator Model: ", userModel);
        }
      });
    }
    catch (error) {
      console.log("error in login: ", error);
    }

    setLoading(false)
  }

  const signinWithGoogleUsingFirebase = () => {
    console.log("signinWithGoogleUsingFirebase");
    signInWithPopup(firebaseAuth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      // Get The Additional User Info if user is new or old user
      const additionalUserInfo:any = getAdditionalUserInfo(result);
      if (credential != null) {
        // const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        const isNewUser = additionalUserInfo.isNewUser;
        if (isNewUser) {
          // delete the created user as user doesn't exist
          result.user.delete();
          formik.setStatus(`User: ${user.email} doesn't exist!`)
        } else {
          // user exist
          result.user.getIdToken().then(function(token){
            console.log("accessToken: ", token);
            const authModel: AuthModel = {
              api_token: token,
              refreshToken: result.user.refreshToken,
            };
            saveAuth(authModel)
          });
          console.log("user: ", user);
          
          getUserRecordFromFirestoreDB(result.user)
        }
      }
    })
    .catch((error) => {
      console.log(error.message);
      formik.setStatus(error.message)
      setLoading(false);
    });
  }

  // Firebase methods - end

  const handleEmailFocus = (e: any) => {
    child.current?.onEmailFocus(e)
  }

  const handleEmailBlur = (e: any) => {
    child.current?.onEmailBlur(e)
  }
  const handleEmailInput = (e: any) => {
    child.current?.onEmailInput(e)
  }

  const handlePasswordFocus = (e: any) => {
    child.current?.onPasswordFocus(e)
  }

  const handlePasswordBlur = (e: any) => {
    child.current?.onPasswordBlur(e)
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-5'>
        <a href='#'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-40px' />
        </a>
      </div>
      {/* begin::Heading */}
      <div className='text-center mb-5'>
        <h1 className='text-dark auth-label'>Welcome back!</h1>
        <div className='text-black-400 fw-bold fs-4'>
          New Here?{' '}
          <Link to='/auth/registration' className='link-primary fw-bolder'>
            Create an Account
          </Link>
        </div>
      </div>
      {/* begin::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}

      {/* begin::SVG Avatar */}
      <div className="position-relative" style={svgContainerStyle}>
        <AnimatedAvatar ref={child} />
      </div>
      {/* end::SVG Avatar */}

      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          id='email'
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
          onFocus={handleEmailFocus}
          onBlur={handleEmailBlur}
          onInput={handleEmailInput}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-5'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
            {/* end::Label */}
            {/* begin::Link */}
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
            >
              Forgot Password ?
            </Link>
            {/* end::Link */}
          </div>
        </div>
        <input
          id='password'
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
          onFocus={handlePasswordFocus}
          onBlur={handlePasswordBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg w-100 mb-3 continue-button'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        {/* begin::Separator */}
        <div className='text-center text-muted text-uppercase fw-bolder mb-3'>or</div>
        {/* end::Separator */}

        {/* begin::Google link */}
        <button type='button' onClick={signinWithGoogleUsingFirebase} className='btn btn-light-primary flex-center btn-light btn-lg w-100'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
            className='h-20px me-3'
          />
          Continue with Google
        </button>
        {/* end::Google link */}
      </div>
      {/* end::Action */}
    </form>
  )
}
